import React, { useEffect, useState } from "react";
import { api_url, titleDescription } from "../../config/Config";
import { Table } from "react-bootstrap";
import _fetch from "../../config/api";
import dateFormat from "dateformat";
import ReactPaginate from "react-paginate";
import { ColorRing } from "react-loader-spinner";
import { useTranslation } from 'react-i18next';

const StakeCompoundingHistory = (props: any) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.title = `${props.pageTitle} | ${titleDescription}`;
  });

  const [loading, setLoading] = useState(true);
  const [page, setpage] = useState(1);
  const [TradeHistory, setTradeHistory] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [totalStake, setTotalStake] = useState(0);
  const [keyCount, setKeyCount] = useState(0);
  const [limit, setLimit] = useState(100);

  useEffect(() => {
    getAllIncomeReport();
  }, [page, totalRecord]);

  const getAllIncomeReport = async () => {
    setLoading(true);
    let res = await _fetch(`${api_url}report/compound-stake-history?limit=${limit}&page=${page}`, "GET", {})
    if (res?.status === "success") {
      setLoading(false);
      setTradeHistory(res?.data);
      setTotalRecord(res?.total);
      setTotalStake(res?.totalAmount);
    }
    if (page > 1) {
      setKeyCount(0);
      var count = page - 1;
      setKeyCount(count * limit);
    }
  }

  const handlePageClick = async (event: any) => {
    const newOffset = (event.selected + 1);
    setpage(newOffset);
  };
  return (
    <main>
      <div className="uni-level-outer">
        <div className="coustom_container">
          <div className="level_inner loader_main">
            {loading &&
              <div className="spinner_bg">
                <div className="color_ring">  <ColorRing
                  visible={true}
                  height="80"
                  width="80"

                  ariaLabel="blocks-loading"
                  wrapperStyle={{}}
                  wrapperClass="blocks-wrapper"
                  colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                /></div>

              </div>
            }
            <div className="top_section_unilevel">
              {/* <div className="date">
                <span className='from'>{t("From")}</span>   <input type='date' className="form-control" placeholder='' onChange={(e: any) => setStartDate(e.target.value)} value={startDate} />
              </div>

              <div className="date">
                <span className='to'>To</span>   <input type='date' className="form-control" placeholder='' onChange={(e: any) => setEndDate(e.target.value)} value={endDate} />
              </div> */}
              {/* {type == 'level_income' && <div className='date'>
                                <span className='select_level'>{t("Level")}</span>
                                <select className="form-control select_option" onChange={(e: any) => setLevelSearch(e.target.value)} >
                                    <option value="">All</option>
                                    {allLevels?.map((item: any, key: any) => (
                                        <option key={key} value={item}> {t('Level') + " " + item} </option>
                                    ))}
                                </select>
                            </div>} */}
              {/* <button type='button' className='btn seach_btn' onClick={() => getIncomeReport()}>{t("Search")}</button> */}

              <p className='level_open'> Total Stake : <span>${totalStake?.toFixed(2)}</span></p>

              <div className="form-btn">

                {/* <button className="searchicons">
                                    <SearchIcon />
                                </button> */}
                {/* <button className="searchicons" onClick={refresh} >
                  <ReplayIcon />
                </button> */}
              </div>
            </div>
            <div className="table_section">
              <div className="scrolling_table">
                <div className="scroll_under">
                  <Table className="support_table">
                    <thead>
                      <tr className="table_heading_row">
                        <th className="table_heading">{t("#")}</th>
                        <th className="table_heading">{t("Amount")}</th>
                        <th className="table_heading">{t("InvestDate")}</th>
                        <th className="table_heading">{t("UnStakeDate")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {TradeHistory?.map((item: any, index: any) => {
                        // const utcDate = new Date(item?.created_at);
                        // const istDate = new Date(utcDate.getTime() + 5.5 * 60 * 60 * 1000);
                        return (
                          <>
                            <tr className="table_data_row">
                              <td className="table_data">{page > 1 ? index + keyCount + 1 : index + 1}</td>
                              <td className="table_data">${item?.amount?.toFixed(2)}</td>
                              <td className="table_data">{item?.investDate} </td>
                              <td className="table_data">
                                <div className="pic_text">{dateFormat(item?.unStakeDate, "dd-mm-yyyy hh:MM:ss TT")}</div>
                              </td>
                            </tr>
                          </>
                        )
                      })}

                    </tbody>
                  </Table>
                  {totalRecord > 100 && <ReactPaginate className="pagination__2 " activeClassName="active"
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={1}
                    pageCount={totalRecord / 100}
                    previousLabel="<"
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StakeCompoundingHistory;
